export function greenDividerFunction() {
    const parent = $(".green-divider.sale");
    const button = parent.find(".close-btn");

    button.on("click", function (e){
        e.preventDefault();

        parent.fadeOut( function (){
            sessionStorage.setItem("hide-sales-tip", $(parent).css("display", "none"));
        });

    });

    if (sessionStorage.getItem("hide-sales-tip")) {
        $(parent).css("display", "none");
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/greenDividerFunction.js